import { ArrowRight } from "./icons";

/**
 * Two stacked arrows that slide through on hover — the first exits right,
 * a second slides in from the left to replace it — driven by the
 * .icon-stack/.icon-stack-track CSS in index.css, scoped to btn-primary/
 * btn-outline/btn-dark-outline so it only needs the enclosing button's
 * :hover state. Only ever rendered at the default 16px size across the
 * site, so the CSS hardcodes that rather than taking size as a variable.
 */
export default function AnimatedArrow({ size = 16 }: { size?: number }) {
  return (
    <span className="icon-stack" aria-hidden="true">
      <span className="icon-stack-track">
        <ArrowRight size={size} />
        <ArrowRight size={size} />
      </span>
    </span>
  );
}
